import logo from './logo.svg';
import Header from './Navbar';
import { BrowserRouter as Router } from 'react-router-dom';
import './index.css';
import Footer from './Footer';
import HeroSection from './Hero';
function App() {
  return (
    <>
     <Router>  
     <div className="max-w-[1800px] min-h-screen	 m-auto">  
      <Header/>
      
      <Footer/>
      </div>
      </Router> 
    </>
  );
}

export default App;
